// /* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { checkAvailability, resetAvailabilityData } from '../../store/actions';
import { Box, Button, CircularProgress, FormControlLabel, Grid, InputAdornment, Modal, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { CssTextField } from '../../components/TextField';
import { useSearchParams ,searchParams} from 'react-router-dom';
import { CalendarMonth, Home } from '@mui/icons-material';
import { Formik } from 'formik';
import moment from 'moment';
import PlusOrMinusButton from '../../components/PlusOrMinusButton';
import RequestBookingModalContent from './requestBookingModalContent';

export default function Page1({ code, setPage, setErrMsg, isPrivate, dispatch, colors, hotelDetails, isLoading, autoNavigated, setAutoNavigated }) {
    const checkinRef = useRef();
    const checkoutRef = useRef();
    const maxPeopleIndividual = hotelDetails?.max_people?.individual ?? 20;
    const maxchild = hotelDetails?.max_people?.child ?? 1;
    const maxPeoplePrivate = hotelDetails?.max_people?.private ?? 20;
    const [pref, setPref] = useState(isPrivate ? "private" : "Room_only");
    const [requestModal, setRequestModal] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    var adults = searchParams.get("adults");
    var children = searchParams.get("children");
    var checkin = searchParams.get("checkin");
    var checkout = searchParams.get("checkout");
    var checkInDate = searchParams.get("CheckInDate") || (checkin ? moment(checkin, "YYYY-MM-DD").format("DD/MM/YYYY") : null);
    var checkOutDate = searchParams.get("CheckOutDate") || (checkout ? moment(checkout, "YYYY-MM-DD").format("DD/MM/YYYY") : null);
    const isWhatsapp = searchParams.get("bookingType") === "whatsapp";
    const isMoksha = searchParams.get("bookingType") === "moksha";
    
    // Check if URL has booking parameters
    const hasUrlParams = !!(checkin && checkout && adults && children);

    // Auto-navigate on initial mount if URL params are present
    useEffect(() => {
        if (autoNavigated) return; // Only run once on mount
        
        // Handle WhatsApp bookings - ensure adults and children are set
        if (isWhatsapp) {
            const adults = searchParams.get("adults");
            const children = searchParams.get("children");

            if (adults && children) {
                if (checkInDate && checkOutDate) {
                    if (setAutoNavigated) setAutoNavigated(true);
                    callCheckAvailaility();
                }
            } else {
                const newParams = new URLSearchParams(searchParams);
                if (!adults) newParams.set("adults", "2");
                if (!children) newParams.set("children", "0");
                setSearchParams(newParams);
            }
        } else if (hasUrlParams && checkInDate && checkOutDate) {
            // For non-WhatsApp bookings, if URL params are present, check availability immediately
            if (setAutoNavigated) setAutoNavigated(true);
            callCheckAvailaility();
        }

        if (maxPeopleIndividual == 0) {
            setPref("private");
        }
        if (maxPeoplePrivate == 0) {
            setPref("Room_only");
        }
    }, []) // Empty dependency array - run only on mount

    const getPrivateMaxChild = () => {
        let num = Math.round(maxPeoplePrivate * 1/3)
        return num;
    }
    // console.log(getPrivateMaxChild);
    

    const callCheckAvailaility = async() => {
        if(!checkInDate || !moment(checkInDate, "DD/MM/YYYY", true).isValid()){
            setErrMsg("Invalid check-in date!");
            return setPage(5);
        }
        else if(!checkOutDate || !moment(checkOutDate, "DD/MM/YYYY", true).isValid()){
            setErrMsg("Invalid check-out date!");
            return setPage(5);
        }
        else if(moment(checkInDate, "DD/MM/YYYY").isBefore(moment().startOf("day"))){
            setErrMsg("Check-in date cannot be lower than current date!");
            return setPage(5);
        }
        else if (moment(checkInDate, "DD/MM/YYYY") > moment(checkOutDate, "DD/MM/YYYY")) {
            setErrMsg("Check-in date cannot be greater than Check-out date!");
            return setPage(5);
        }

        if(checkInDate === checkOutDate){
            checkOutDate = moment(checkOutDate, "DD/MM/YYYY").add(1, "day").format("DD/MM/YYYY");
        }
        let data = {
            hotelCode: code,
            checkinDate: moment(checkInDate, "DD/MM/YYYY").startOf("day").unix(),
            checkoutDate: moment(checkOutDate, "DD/MM/YYYY").startOf("day").unix(),
            numOfAdults: adults || 2,
            numOfChilds: children || 0,
            totalRooms: 1,
            showAll: true,
            ...(isMoksha && { booking_from: "moksha" }),
        }
        dispatch(checkAvailability(data));
        localStorage.setItem("checkingData", JSON.stringify(data));
        setPage(2);
    }

    const initialValues = {
        checkinDate: checkin ? checkin : moment().format("YYYY-MM-DD"),
        checkoutDate: checkout ? checkout : moment().add(1, "days").format("YYYY-MM-DD"),
        numOfAdults: adults ? parseInt(adults) : 2,
        numOfChilds: children ? parseInt(children) : 0,
        totalRooms: 1,
    };

    const handleFormSubmit = async (values) => {
        let data = {
            ...values,
            hotelCode: code,
            checkinDate: moment(values.checkinDate, "YYYY-MM-DD").unix(),
            checkoutDate: moment(values.checkoutDate, "YYYY-MM-DD").unix(),
            isPrivate: pref === "private" ? true : false,
            ...(isMoksha && { booking_from: "moksha" }),
        }
        // console.log(data);
        dispatch(resetAvailabilityData());
        dispatch(checkAvailability(data));
        localStorage.setItem("checkingData", JSON.stringify(data));
        
        // Update URL with new search params only if there were already values in URL
        if (checkInDate || checkOutDate || adults || children) {
            const newParams = new URLSearchParams(searchParams);
            if (checkin || checkout) {
                newParams.set("checkin", values.checkinDate);
                newParams.set("checkout", values.checkoutDate);
            } else {
                newParams.set("CheckInDate", values.checkinDate);
                newParams.set("CheckOutDate", values.checkoutDate);
            }
            newParams.set("adults", values.numOfAdults);
            newParams.set("children", values.numOfChilds);
            setSearchParams(newParams);
        }
        
        if (setAutoNavigated) setAutoNavigated(true);
        setPage(2);
    }

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { sm: 600, xs: "90%" },
        bgcolor: colors.primary[400],
        outline: "none",
        boxShadow: 24,
        p: 2,
    };


    return (
        <>
            <Stack minHeight="95vh" justifyContent="center" alignItems="center">
                <Grid container spacing={2} justifyContent="center">
                    <Grid item md={6} xs={12} mt={2} mb={2}>
                        <Stack
                            p={1}
                            // pl={2}
                            // pr={2}
                            spacing={{ md: 2, xs: 1 }}
                            width="100%"
                            direction="row"
                            bgcolor={colors.greenAccent[700]}
                            // color="#000"
                            justifyContent="space-between"
                        >
                            <Stack direction="row" spacing={1}>
                                <Home />
                                <Typography textTransform={"uppercase"} fontWeight="bold">
                                    {hotelDetails?.name || "-"}
                                </Typography>
                            </Stack>
                            {/* <Stack direction="row" spacing={1}>
                                <BorderAll />
                                <Typography textTransform={"uppercase"} fontWeight="bold">
                                    {hotelDetails?.property?.type || "-"}
                                </Typography>
                            </Stack>
                            <Stack direction="row" spacing={1}>
                                <Place />
                                <Typography textTransform={"uppercase"} fontWeight="bold">
                                    {hotelDetails?.address || "-"}
                                </Typography>
                            </Stack> */}
                        </Stack>
                        <Stack
                            p={2}
                            // bgcolor={colors.primary[400]}
                            bgcolor={"rgb(0, 0, 0, 0.7)"}
                            style={{backdropFilter: `blur(3px)`}}
                        >
                            <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
                                {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Grid container spacing={2} alignItems="start">
                                            <Grid item md={6} xs={12}>
                                                <Typography><b>Check-in date</b></Typography>
                                                <CssTextField
                                                    fullWidth
                                                    required
                                                    size='small'
                                                    type="date"
                                                    placeholder="Check-in date"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                        if (moment(e.target.value).add(1, "days").format("YYYY-MM-DD") > values.checkoutDate) {
                                                            setFieldValue(
                                                                'checkoutDate',
                                                                moment(e.target.value).add(1, "days").format("YYYY-MM-DD")
                                                            );
                                                        }
                                                    }}
                                                    value={values.checkinDate}
                                                    name="checkinDate"
                                                    error={!!touched.checkinDate && !!errors.checkinDate}
                                                    helperText={touched.checkinDate && errors.checkinDate}
                                                    inputProps={{ min: moment().format("YYYY-MM-DD") }}
                                                    inputRef={checkinRef}
                                                    onClick={() => checkinRef.current.showPicker()} 
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <CalendarMonth sx={{ cursor: "pointer" }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    // disabled={page === 2}
                                                />
                                            </Grid>
                                            <Grid item md={6} xs={12}>
                                                <Typography><b>Check-out date</b></Typography>
                                                <CssTextField
                                                    fullWidth
                                                    required
                                                    size="small"
                                                    type="date"
                                                    placeholder="Checkout Date"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.checkoutDate}
                                                    name="checkoutDate"
                                                    error={!!touched.checkoutDate && !!errors.checkoutDate}
                                                    helperText={touched.checkoutDate && errors.checkoutDate}
                                                    inputProps={{ min: moment(values.checkinDate).add(1, "days").format("YYYY-MM-DD") }}
                                                    inputRef={checkoutRef}
                                                    onClick={() => checkoutRef.current.showPicker()} 
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <CalendarMonth sx={{ cursor: "pointer" }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    // disabled={page === 2}
                                                />
                                            </Grid>
                                            
                                            {/* <Grid item md={6} xs={12}></Grid> */}
                                            <Grid item md={6} xs={12}>
                                                <Typography><b>Number of adults / room</b></Typography>
                                                <PlusOrMinusButton
                                                    min={1}
                                                    max={pref === "private" ? maxPeoplePrivate : maxPeopleIndividual}
                                                    name="numOfAdults"
                                                    value={values.numOfAdults}
                                                    handleChange={(value) => setFieldValue("numOfAdults", value)}
                                                />
                                            </Grid>
                                            <Grid item md={6} xs={12}>
                                                <Typography><b>Number of children / room</b></Typography>
                                                <PlusOrMinusButton
                                                    min={0}
                                                    max={isPrivate ? getPrivateMaxChild() : maxchild}
                                                    name="numOfChilds"
                                                    value={values.numOfChilds}
                                                    handleChange={(value) => setFieldValue("numOfChilds", value)}
                                                />
                                                <Typography fontSize="small">Child age: 6-12</Typography>
                                            </Grid>
                                            <Grid item md={6} xs={12} mt={-2}>
                                                <Typography><b>Total rooms</b></Typography>
                                                <PlusOrMinusButton
                                                    min={1}
                                                    disabled={pref === "private"}
                                                    max={pref === "private" ? 1 : 30}
                                                    name="totalRooms"
                                                    value={values.totalRooms}
                                                    handleChange={(value) => setFieldValue("totalRooms", value)}
                                                />
                                            </Grid>
                                            {isPrivate ? (
                                                <Grid item md={12} xs={12}>
                                                    <Typography><b>Book</b></Typography>
                                                    <RadioGroup
                                                        row
                                                        value={pref}
                                                        onChange={(e) => setPref(e.target.value)}
                                                    >
                                                        <FormControlLabel disabled={maxPeoplePrivate == 0} value="private" control={<Radio />} label="Entire Property" />
                                                        {/* <FormControlLabel disabled={maxPeopleIndividual == 0} value="Room_only" control={<Radio />} label="Individual Room" /> */}
                                                    </RadioGroup>
                                                </Grid>
                                            ) : null}
                                            {/* {!isPrivate ? (
                                                <Grid item md={6} xs={12}></Grid>
                                            ) : null}  */}
                                            <Grid item md={12} xs={12}>
                                                <Button
                                                    fullWidth
                                                    // size="small"
                                                    type="submit"
                                                    color="secondary"
                                                    variant="contained"
                                                    // disabled={page === 2}
                                                    sx={{ fontSize: "15px" }}
                                                >
                                                    {isLoading ? <CircularProgress color="inherit" size={24} /> : <b>Check availability</b>}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            </Formik>
                            <Stack alignItems="end" mt={2}>
                                <Button
                                    size="small"
                                    variant='text'
                                    sx={{ letterSpacing: 1, borderRadius: 20, p: 0, pl: 1, pr: 1 }}
                                    onClick={() => setRequestModal(true)}
                                >
                                    <b>Enquire a booking</b>
                                </Button>
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
            </Stack>

            <Modal
                open={requestModal}
                onClose={() => setRequestModal(false)}
            >
                <Box sx={modalStyle}>
                    <RequestBookingModalContent code={code} dispatch={dispatch} isLoading={isLoading} setRequestModal={setRequestModal}/>
                </Box>
            </Modal>
        </>
    )
}